import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { DragIndicator } from '@material-ui/icons';
import { Row, StyledBannerTitle, StyledContainer, StyledHeader, StyledInputsContainer } from './Banner.styled';
import { InputField } from '../../../../healtheraComponents';
import { StyledCancelIcon } from '../../PlusWebsiteEditor.styles';
import ImageUploader from '../ImageUploader/ImageUploader';
import { DraggableHOC } from '../DraggableHOC/DraggableHOC';
import { Banner as IBanner } from '../../types/banners';
import { Base64 } from '../../types/websiteConfiguration';
import { BlurHandler } from '../../types/handlers';

type Props = {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  item: IBanner;
  index: number;
  onDelete: () => void;
  onImageChange: (image: Base64) => void;
  onFieldChange: (fieldName: string, value: string) => void;
  onBlur: BlurHandler;
  error: Record<keyof IBanner, string | null> | null;
};

export const Banner = ({ provided, snapshot, item, index, error, onBlur, onDelete, onImageChange, onFieldChange }: Props) => (
  <DraggableHOC snapshot={snapshot} provided={provided}>
    <StyledContainer ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
      <StyledHeader>
        <DragIndicator />
        <StyledBannerTitle>{`Banner ${index + 1}`}</StyledBannerTitle>
        <StyledCancelIcon onClick={onDelete} />
      </StyledHeader>
      <Row>
        <StyledInputsContainer>
          <InputField helperText={error?.title} onBlur={onBlur} onChange={(e) => onFieldChange('title', e.target.value)} margintop="20px" label="Title" defaultValue={item.title} />
          <InputField helperText={error?.link} onBlur={onBlur} onChange={(e) => onFieldChange('link', e.target.value)} margintop="20px" label="Link" defaultValue={item.link} />
        </StyledInputsContainer>
        <ImageUploader helperText={error?.image} onChange={onImageChange} title="Banner Image" url={item.image || item.image_url} />
      </Row>
    </StyledContainer>
  </DraggableHOC>
);
